var PasswordValidation = /** @class */ (function () {
    function PasswordValidation() {
    }
    PasswordValidation.validate = function (registrationFormGroup) {
        var password = registrationFormGroup.controls.password.value;
        var repeatPassword = registrationFormGroup.controls.confirmPassword.value;
        if (!repeatPassword || repeatPassword.length <= 0) {
            return null;
        }
        if (repeatPassword !== password) {
            return registrationFormGroup.controls.confirmPassword.setErrors({
                doesNotMatchPassword: true
            });
        }
        return null;
    };
    return PasswordValidation;
}());
export { PasswordValidation };
